import rootReducer from './rootReducer';
import { useSelector } from 'react-redux';

export type AppState = ReturnType<typeof rootReducer>;

export const useAppState = <T>(selector: (state: AppState) => T): T => {
    return useSelector<AppState, T>(selector);
};
